import { useTranslation } from 'react-i18next';
import { Dialog } from '@/components/ui';

export interface IosPwaGuideModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/** "Add to Home Screen" guide for iOS: the static illustrated guide in a centred, widest Dialog. */
export default function IosPwaGuideModal({
  isOpen,
  onClose,
}: IosPwaGuideModalProps) {
  const { t } = useTranslation();
  const option3HtmlUrl = `${import.meta.env.BASE_URL}ios_guide/option-3-dark-premium.html`;

  // Dialog owns Escape (closes), the close button (focused first), focus trap and scroll lock;
  // a backdrop click does nothing, as before.
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={t('supportRail.iosGuide.title')}
      closeLabel={t('supportRail.closeIosGuideAriaLabel')}
      size="xl"
      placement="center"
    >
      <iframe
        src={option3HtmlUrl}
        title={t('supportRail.iosGuide.title')}
        className="block h-[min(70dvh,53.75rem)] w-full rounded-container border border-edge-subtle bg-card"
      />
    </Dialog>
  );
}
